import axios, { InternalAxiosRequestConfig } from 'axios';
import { useCallback, useEffect } from 'react';

import { useGetAccessToken } from './use-get-access-token';

const Authorization = 'Authorization';

export const useAuthHeaders = () => {
  const getAccessToken = useGetAccessToken();

  const interceptor = useCallback(
    async (request: InternalAxiosRequestConfig) => {
      const token = await getAccessToken();

      if (request.headers) {
        request.headers[Authorization] = `Bearer ${token}`;
      }

      return request;
    },
    [getAccessToken],
  );

  useEffect(() => {
    const interceptorId = axios.interceptors.request.use(interceptor);

    return () => axios.interceptors.request.eject(interceptorId);
  }, [interceptor]);
};
